export const environment = {
  production: false,
  staging: true,
  development: false,
  apiUrl: 'https://api-staging.getkarta.ai/admin',
  batchApiUrl: 'https://t61o9djpm8.execute-api.us-east-1.amazonaws.com/stage',
  callLogsApiUrl: 'https://whpln8z73k.execute-api.us-east-1.amazonaws.com/default',
  toolsApiUrl: 'https://4nvjwcqbdl.execute-api.us-east-1.amazonaws.com/stage',
  dashboardUrl: 'https://dashboard-staging.getkarta.ai',
  livekit: {
    url: 'wss://karta-plivo-u3xjbqle.livekit.cloud',
    serverUrl: 'https://karta-plivo-u3xjbqle.livekit.cloud/settings/regions',
    apiKey: 'APIEF8rSicsTTjv',
    apiSecret: 'RXoByeJyCVTGL7OJqYcmqlx4X9GQbfSpBbjsgidnRHW'
  }
}; 
